import Study2Model from '@/models/study2'
const study2 = new Study2Model()

const MUTATIONS_TYPE = {
  SET_CURRENT_LESSON: 'SET_CURRENT_LESSON',
  SET_CURRENT_ELEMENT: 'SET_CURRENT_ELEMENT',
  SET_ELEMENT_SUBMIT_STATUS: 'SET_ELEMENT_SUBMIT_STATUS',
  RESET_ELEMENT: 'RESET_ELEMENT',
  LESSON: 'LESSON',
  RESET_LESSON: 'RESET_LESSON',
  SET_HIGH_WORD: 'SET_HIGH_WORD',
  SET_STATUS: 'SET_STATUS',
  SET_ELEMENT_RESULT: 'SET_ELEMENT_RESULT'
}

const STUDY = {
  START: 'STUDY_START',
  RESULT: 'STUDY_RESULT',
  TIME: 'STUDY_TIME',
  FINISH: 'STUDY_FINISH',
  MEDIA_PAUSE: 'STUDY_MEDIA_PAUSE',
  MEDIA_REPEAT: 'STUDY_MEDIA_REPEAT',
}

export default {
  namespaced: true,
  state: {
    lesson: null, // 当前课时
    element: null, // 当前元素]
    highWord: null, //当前题目的评分
    problemStatus: null, //自读元素使用记录第几次提交答案
  },
  getters: {
    lesson: (state) => state.lesson,
    element: (state) => state.element,
    highWord: (state) => state.highWord,
    problemStatus: (state) => state.problemStatus,
  },
  mutations: {
    /**
     * @description 设置当前元素
     */
    [MUTATIONS_TYPE.SET_CURRENT_ELEMENT](state, payload) {
      // 去除掉 records 中 eleId 相同的记录
      const records = payload.records ? payload.records : []
      const uniqueRecords = [...new Map(records.map(item => [item.eleId, item])).values()];
      // 从 payload.datas 中过滤掉已经存在的记录
      const answeredIds = new Set(uniqueRecords.map(record => record.eleId));
      const unansweredList = payload.datas ? payload.datas.filter(item => !answeredIds.has(item.id)) : [];
      state.element = {
        ...payload,
        RECORD_ID: `${this.state.user.user.id}_${payload.id}`,
        totalCount: payload.datas ? payload.datas.length : 0,
        unansweredList,
        currentCount:
          payload.records && payload.records.length
            ? payload.records.length + 1
            : 1,
      }
    },
    /**
     * @description 设置当前元素的结果
     */
    [MUTATIONS_TYPE.SET_ELEMENT_RESULT](state, payload) {
      state.element.records = payload
    },
    /**
     * @description 设置当前课时
     */
    [MUTATIONS_TYPE.SET_CURRENT_LESSON](state, payload) {
      if (!payload) {
        if (localStorage.getItem(`${MUTATIONS_TYPE.LESSON}`)) {
          state.lesson = JSON.parse(
            localStorage.getItem(`${MUTATIONS_TYPE.LESSON}`)
          )
        }
      } else {
        localStorage.setItem(
          `${MUTATIONS_TYPE.LESSON}`,
          JSON.stringify(payload)
        )
        state.lesson = payload
      }
    },
    [MUTATIONS_TYPE.RESET_LESSON](state) {
      state.lesson = null
      localStorage.removeItem('LESSON')
    },
    /**
     * @description 清除当前元素
     */
    [MUTATIONS_TYPE.RESET_ELEMENT](state) {
      state.element = null
    },
    /**
     * @description 设置当前元素答案是否提交成功；元素监听 element.isSubmit true则表示提交成功，表示可以继续提交答案后的操作，答案后的操作完成后触发 next
     * @param {*} state
     */
    [MUTATIONS_TYPE.SET_ELEMENT_SUBMIT_STATUS](state, payload) {
      state.element.isSubmit = payload
    },
    /**
     * @description 设置当前题目评分
     */
    [MUTATIONS_TYPE.SET_HIGH_WORD](state, payload) {
      state.highWord = payload
    },
    /**
     * @description 设置当前题第几次作答
     */
    [MUTATIONS_TYPE.SET_STATUS](state, payload) {
      state.problemStatus = payload
    },
  },
  actions: {
    /**
     * 开始闯关
     */
    async [STUDY.START]({ state }, { elementId }) {
      console.log('开始闯关：', elementId)
      try {
        let res = await study2.upload({
          id: state.lesson.topId,
          elementId,
          elementCommand: Study2Model.COMMAND.LEARN,
        })
        return res.data
      } catch (error) {
        throw new Error(error.msg || error.message)
      }
    },
    /**
     * 提交闯关记录（题）
     */
    async [STUDY.RESULT]({ state, commit }, { elementId, postData }) {
      console.log('提交闯关记录：', elementId)
      try {
        let res = await study2.upload({
          id: state.lesson.topId,
          elementId,
          elementCommand: Study2Model.COMMAND.RESULT,
          data: postData,
        })
        // 重置结果
        commit(MUTATIONS_TYPE.SET_ELEMENT_RESULT, res.data.records)

        return res.data
      } catch (error) {
        throw new Error(error.msg || error.message)
      }
    },
    /**
     * 更新开始时间
     */
    async [STUDY.TIME]({ state, commit }, { elementId }) {
      console.log('更新开始时间：', elementId)
      try {
        let res = await study2.upload({
          id: state.lesson.topId,
          elementId,
          elementCommand: Study2Model.COMMAND.TIME,
        })
        // 重置时间
        commit(MUTATIONS_TYPE.SET_CURRENT_ELEMENT, {
          ...state.element,
          time: res.data.time,
        })

        return res.data
      } catch (error) {
        throw new Error(error.msg || error.message)
      }
    },
    /**
     * 闯关完成
     */
    async [STUDY.FINISH]({ commit, state }, { elementId, postData = {} }) {
      try {
        let res = await study2.upload({
          id: state.lesson.topId,
          elementId,
          elementCommand: Study2Model.COMMAND.LEARN_FINISH,
          ...postData,
        })
        commit(MUTATIONS_TYPE.SET_ELEMENT_SUBMIT_STATUS, true)
        return res.data
      } catch (error) {
        console.log('结束闯关error:', error)
        throw new Error(error.msg || error.message)
      }
    },
    /**
     * 闯关中-媒体暂停
     */
    async [STUDY.MEDIA_PAUSE]({ commit, state }, { elementId }) {
      console.log('暂停媒体闯关：', elementId)
      try {
        let res = await study2.upload({
          id: state.lesson.topId,
          elementId,
          elementCommand: Study2Model.COMMAND.PAUSE,
        })

        // 重置剩余暂停次数
        commit(MUTATIONS_TYPE.SET_CURRENT_ELEMENT, {
          ...state.element,
          pause: res.data ? res.data.pause : false,
        })
        return true
      } catch (error) {
        throw new Error(error.msg || error.message)
      }
    },
    /**
     * 闯关中-重播媒体
     */
    async [STUDY.MEDIA_REPEAT]({ commit, state }, { elementId }) {
      console.log('重播媒体闯关：', elementId)
      try {
        let res = await study2.upload({
          id: state.lesson.topId,
          elementId,
          elementCommand: Study2Model.COMMAND.REPEAT,
        })

        // 重置剩余重播次数
        commit(MUTATIONS_TYPE.SET_CURRENT_ELEMENT, {
          ...state.element,
          repeat: res.data.repeat,
        })
        return true
      } catch (error) {
        throw new Error(error.msg || error.message)
      }
    },
    /**
     * 整听整看完成 
     */
    async PREVIEW_FINISH(context, { id }) {
      console.log('整听整看完成：', id)
      try {
        let res = await study2.uploadPreview({
          id
        })

        if (res.data) {
          return true
        } else {
          throw new Error(res.msg || false)
        }
      } catch (error) {
        throw new Error(error.msg || error.message)
      }
    }
  },
}
